<app-thi-page-shell [lang]="landingLang">
  <div class="overflow-hidden">
    <section class="relative pt-40 pb-16 thi-section-gradient-soft overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-4xl mx-auto text-center">
          <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-6">
            <i class="fa fa-comments text-3xl text-primary" aria-hidden="true"></i>
          </div>
          <h1 class="text-4xl md:text-5xl font-bold text-foreground mb-4">{{ c.heroTitle }}</h1>
          <p class="text-xl text-muted-foreground">{{ c.heroSubtitle }}</p>
        </div>
      </div>
    </section>

    <section class="py-16 bg-background">
      <div class="container mx-auto px-4 max-w-5xl">
        <div
          class="thi-surface-gradient-wa border-2 border-primary/30 rounded-3xl p-8 md:p-12 mb-8 shadow-lg"
        >
          <div class="flex flex-col md:flex-row items-center gap-8">
            <div
              class="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-3xl bg-primary flex items-center justify-center shadow-md"
            >
              <i class="fa fa-whatsapp text-4xl md:text-5xl text-primary-foreground" aria-hidden="true"></i>
            </div>
            <div class="flex-1 text-center md:text-start">
              <div class="inline-block px-3 py-1 rounded-full bg-primary/15 text-primary text-xs font-semibold mb-3">
                {{ c.primaryChannel }}
              </div>
              <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-3">{{ c.whatsappLabel }}</h2>
              <p class="text-muted-foreground leading-relaxed mb-4">{{ c.primaryChannelDesc }}</p>
              <p class="text-foreground font-semibold mb-5" dir="ltr">{{ c.whatsappValue }}</p>
              <button
                type="button"
                (click)="openWhatsApp()"
                class="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-xl font-semibold hover:opacity-90 transition-opacity shadow-md"
              >
                <i class="fa fa-whatsapp"></i>
                {{ c.whatsappCta }}
              </button>
            </div>
          </div>
        </div>

        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-8 text-center">{{ c.contactInfo }}</h2>

        <div class="grid md:grid-cols-2 gap-6 mb-8">
          <div class="bg-card border border-border rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div class="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
              <i class="fa fa-clock-o text-xl text-primary"></i>
            </div>
            <h3 class="text-lg font-bold text-foreground mb-2">{{ c.hours }}</h3>
            <p class="text-muted-foreground text-sm leading-relaxed">{{ c.hoursValue }}</p>
            <p class="text-muted-foreground text-sm leading-relaxed mt-2">{{ c.responseTime }}</p>
          </div>

          <a
            (click)="openEmail(); $event.preventDefault()"
            href="mailto:support@thinvoices.com"
            class="bg-card border border-border rounded-2xl p-6 shadow-sm hover:shadow-md hover:border-primary/40 transition-shadow duration-200 group block cursor-pointer"
          >
            <div class="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20">
              <i class="fa fa-envelope text-xl text-primary"></i>
            </div>
            <h3 class="text-lg font-bold text-foreground mb-2">{{ c.emailLabel }}</h3>
            <p class="text-primary font-medium text-sm break-all">support@thinvoices.com</p>
          </a>
        </div>
      </div>
    </section>

    <section class="py-16 bg-secondary/30">
      <div class="container mx-auto px-4 max-w-4xl">
        <div class="text-center mb-12">
          <div class="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 mb-4">
            <i class="fa fa-question-circle text-2xl text-primary"></i>
          </div>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground">{{ c.faqTitle }}</h2>
        </div>

        <div class="space-y-4">
          <div
            *ngFor="let faq of c.faqs"
            class="bg-card border border-border rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <div class="flex items-start gap-4">
              <div class="flex-shrink-0 w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                <i class="text-primary" [ngClass]="faqIconClass(faq.icon)"></i>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-bold text-foreground mb-2">{{ faq.q }}</h3>
                <p class="text-muted-foreground leading-relaxed">{{ faq.a }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="py-16 bg-background">
      <div class="container mx-auto px-4 max-w-4xl">
        <div class="thi-surface-gradient-panel border border-primary/20 rounded-2xl p-8 md:p-10">
          <div class="flex items-start gap-4 mb-6">
            <div class="flex-shrink-0 w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center">
              <i class="fa fa-user-times text-2xl text-primary"></i>
            </div>
            <div class="flex-1">
              <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-3">{{ c.deleteTitle }}</h2>
              <p class="text-muted-foreground leading-relaxed">{{ c.deleteIntro }}</p>
            </div>
          </div>

          <div class="bg-card border border-border rounded-xl p-6 ms-0 md:ms-16">
            <p class="text-foreground font-medium mb-3">{{ c.deleteSendTo }}</p>
            <a href="mailto:support@thinvoices.com" class="inline-flex items-center gap-2 text-primary font-semibold hover:underline mb-4">
              <i class="fa fa-envelope"></i>
              support@thinvoices.com
            </a>
            <div class="flex items-start gap-2 pt-4 border-t border-border">
              <i class="fa fa-shield text-primary flex-shrink-0 mt-0.5"></i>
              <p class="text-muted-foreground text-sm leading-relaxed">{{ c.deleteConfirm }}</p>
            </div>
          </div>
        </div>

        <div class="mt-12 text-center">
          <h3 class="text-lg font-semibold text-foreground mb-4">{{ c.keyLinksTitle }}</h3>
          <div class="flex flex-wrap justify-center gap-4 text-sm">
            <a routerLink="/privacy-policy" class="text-primary hover:underline">{{ c.privacy }}</a>
            <span class="text-border">·</span>
            <a routerLink="/terms-of-service" class="text-primary hover:underline">{{ c.terms }}</a>
            <span class="text-border">·</span>
            <a [href]="registrationCertificatePdfUrl" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">
              {{ c.registrationCert }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</app-thi-page-shell>
